// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '20250722.03.f372ae6',
  baseApiUrl: 'https://api.myumsc.uat.bugzstudio.com',
  baseWebSocketUrl: 'wss://api.myumsc.uat.bugzstudio.com',
  // baseApiUrl: 'http://localhost:30020',
  // baseWebSocketUrl: 'ws://localhost:30020',
  stimulsoftLicenseKey:
    '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmzPY1U6l3zaxAj2V366ebz3twzxBesBvUSLzSykFeuYJUIyoaRCEH0+B9j2XrpotGcgO7YhA9W0ED3h/q+7Xjam/WmISp962HXKqpIBOnYNxEa0uKY/ogCXam69vGE7nY4QfoXAahZ8ErwWfoLyajkp9vdcOMlgjcc1FifKn/O/O3tQhAamyHgc0fjP5YWXZOwWn0eKF7Tfe17iUaQmNJ2vFwGi+z5flLbzIZ8wjVEfk+wDhBJ+8jmBCHueEPSEKhOG26FRW2QkvMscZZPCVPlUwx+XUQNj9Du7Qssg6rl4LJYiUQSaK2bInF8OB8Gj4IjDjr1Q5L8A1kE8zf3J0IDBVyDOsLNfVECXcZB79P5PvJBI21MLGiwHH0zGsBnhVhwa5SIpqc3ydVCrCvt2H/YaGqt+QZhAUleBT88pQPFRa0gax9BUre3Crs9IAPWwQ48APJ/leoS9vwDGERixCnWoZ2KkZZPyY7DZIhiQyjIJWo2+dKeK1xm5aY1cdV1z3FZIKDgRkwEuOFeukKGqaQy',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
